import * as React from "react";
import { TextField } from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/es";

dayjs.locale("es");

export default function Calendario({
  onDateChange,
  habilitarpasado,
  modoNacimiento,
}) {
  const [selectedDate, setSelectedDate] = React.useState(null);

  const handleDateChange = (newValue) => {
    setSelectedDate(newValue);
    onDateChange(newValue);
  };

  // Rango permitido para fechas de nacimiento (de hace 18 años hacia atrás)
  const maxFechaNacimiento = dayjs().subtract(18, "year");
  const minFechaNacimiento = dayjs("1900-01-01");

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]}>
        <DatePicker
          autoFocus
          disablePast={!habilitarpasado && !modoNacimiento}
          disableFuture={modoNacimiento}
          minDate={modoNacimiento ? minFechaNacimiento : undefined}
          maxDate={modoNacimiento ? maxFechaNacimiento : undefined}
          value={selectedDate}
          onChange={handleDateChange}
          renderInput={(params) => <TextField {...params} />}
          sx={{
            width: { xs: "100%", sm: "100%", md: "100%" },
            height: "40px",
            "& .MuiInputBase-input": {
              padding: "8px",
              fontSize: { xs: "12px", sm: "14px" },
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ccc",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#1976d2",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#1976d2",
            },
            "& .MuiInputLabel-root": {
              lineHeight: "1.5",
              transform: "translate(14px, 8px) scale(1)",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              transform: "translate(14px, -5px) scale(0.75)",
            },
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
